export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_725_ACTUAL': 'Actual',
    '_726_TARGET': 'Target',
    '_768__TO_TARGET': '% to Target',
    '_773_PERIOD': 'Period'
};
